import { render, staticRenderFns } from "./PwaLayout.vue?vue&type=template&id=990d0742&scoped=true"
import script from "./PwaLayout.vue?vue&type=script&lang=js"
export * from "./PwaLayout.vue?vue&type=script&lang=js"
import style0 from "./PwaLayout.vue?vue&type=style&index=0&id=990d0742&prod&lang=css"
import style1 from "./PwaLayout.vue?vue&type=style&index=1&id=990d0742&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "990d0742",
  null
  
)

export default component.exports